import React, { FC } from 'react'
import { Trans, t } from '@lingui/macro'
import { isEmpty, filter } from 'lodash'
import { Link } from 'react-router-dom'

import { staticLinks } from 'shared/linkBuilder'
import Loader from '../../../components/common/loader/Loader'
import TagList from './components/TagList'
import EventGrid from '../../manage-events/components/event-grid/EventGrid'
import PageHeader from '../../../components/common/page/header/PageHeader'
import { OrganisationRoleEnum } from 'types/Organisation'
import {
  ListEventsAsEditorQuery,
  useListEventsAsEditorQuery,
  useListTagsWithEventCountsQuery
} from './UpcomingEventsPage.codegen'
import {
  UpcomingEventsQuery,
  useUpcomingEventsQuery
} from '../../manage-events/components/upcoming-events-row/UpcomingEventsRow.codegen'
import dayjs from 'shared/dayjs'
import { ButtonOutline } from 'front-end/src/components'
import { AdminOnlyAllowed } from '../../../components/common/AdminOnlyAllowed'
import { IconGridManage } from 'front-end/src/components/common/icon/IconGridManage'
import IconEmptyEvent from 'public/assets/img/empty-event.svg'
import { usePublicApiSession } from 'front-end/src/public-api/hooks/usePublicApiSession'

export const UpcomingEventsPage: FC = () => {
  const { session } = usePublicApiSession()

  const isStudent =
    session?.user.organisation_role === OrganisationRoleEnum.STUDENT

  const gqlHook = isStudent
    ? useUpcomingEventsQuery
    : useListEventsAsEditorQuery

  const eventsResponse = gqlHook({
    variables: {
      endingFrom: dayjs().startOf('minute').toISOString()
    }
  })

  const tagsResponse = useListTagsWithEventCountsQuery({
    variables: {
      endingFrom: dayjs().startOf('minute').toISOString()
    }
  })

  if (eventsResponse.loading || tagsResponse.loading || !tagsResponse.data) {
    return <Loader />
  }

  const { tags: allTags } = tagsResponse.data
  const tags = filter(allTags, ({ eventsCount }) => eventsCount > 0)
  const events = isStudent
    ? (eventsResponse?.data as UpcomingEventsQuery)?.events
    : (eventsResponse?.data as ListEventsAsEditorQuery)?.admin?.organisation
        ?.events

  return (
    <>
      <PageHeader
        fullWidth
        title={t`Upcoming events`}
        className="PageHeader"
        controls={
          <AdminOnlyAllowed allowManagerAccess>
            <ButtonOutline
              leftIcon={<IconGridManage />}
              as={Link}
              to={staticLinks.manageEvents}
            >
              <Trans>Manage events</Trans>
            </ButtonOutline>
          </AdminOnlyAllowed>
        }
      />
      {isEmpty(events) ? (
        <div className="no-items">
          <img src={IconEmptyEvent} alt={t`Empty event`} />
          <h2>
            <Trans>Your calendar is clear</Trans>
          </h2>
          <p>
            <Trans>There are no upcoming events for you to attend.</Trans>
          </p>
        </div>
      ) : (
        <>
          <TagList tags={tags} />
          <EventGrid events={events as any} />{' '}
        </>
      )}
    </>
  )
}
